import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getBillingViaID = (billingId: number | undefined): Promise<IGetBillingViaID> => {
  return axiosDefaultApi.get(`/api/Billing/GetDataForDataLineViaID/${billingId}`);
};

type QueryFnType = typeof getBillingViaID;

type UsegetBillingViaIDOptions = {
  billingId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetBillingViaID = ({ billingId , config }: UsegetBillingViaIDOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getBillingViaID_${billingId}`],
    queryFn: () => getBillingViaID(billingId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Ελέγχου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};